
// eslint-disable-next-line import/prefer-default-export
export function getUserIdleTimeConfig(isAdmin) {
  return isAdmin ? 540000 : 300000;
}



// WEBPACK FOOTER //
// ./src/util/idle.js